<template>
  <div>

    <xolas-table
      table-ref="tenancy-expiry-table"

      title="Tenancy Expiry"
      icon="fa fa-calendar-day"

      url="/tenancy/expiry"
      :fields="fields"

      sort-field="siteName"
      search-placeholder="Landowner, Site Name, Site Group..."

      layer-component="propertyDetails"
      :layer-args="{ id: 'id' }">

      <template #expiry-details="props">
        <!-- eslint-disable-next-line vue/no-v-html -- formatter output, developer-controlled HTML (enum → icon markup) -->
        <span v-html="formatSiteStatus(props.rowData.status)" /> - <span class="text-black">{{props.rowData.landowner}}</span> <b v-if="props.rowData.countOwners > 1"> (#{{props.rowData.countOwners}} owners)</b>
        <b class="text-primary">{{props.rowData.siteName}}</b> <small class="text-info">({{props.rowData.siteId}})</small>
        <div class="pull-right">{{formatDate(props.rowData.expiry)}} | <span :class="props.rowData.expiryDays <= 30 ? 'text-danger' : (props.rowData.expiryDays >= 31 && props.rowData.expiryDays <= 90 ? 'text-warning' : 'text-success')">{{formatFriendlyDate(props.rowData.expiry)}}</span></div>
      </template>

  </xolas-table>

</div>

</template>

<script>

import ArrayMixins from '@/mixins/ArrayMixins'
import SiteMixins from '@/mixins/SiteMixins'

export default {
  mixins: [ArrayMixins, SiteMixins],

  data () {
    return {
      fields: [
        {
          name: '__slot:expiry-details'
        }
      ]
    }
  }
}
</script>

<!-- Dev-parity: zero horizontal cell padding + tight line-height to match the
     legacy vuetable-2 render (dev <td> uses `12px 0`). -->
<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; }
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { line-height: 1.25; }
</style>
